"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-cycle
const SlotCoverSnappingBase_1 = __importDefault(require("./SlotCoverSnappingBase"));
class TSlotCoverSnapping extends SlotCoverSnappingBase_1.default {
}
exports.default = TSlotCoverSnapping;
